import { render, staticRenderFns } from "./chengjiChange.vue?vue&type=template&id=0139275f&scoped=true"
import script from "./chengjiChange.vue?vue&type=script&lang=js"
export * from "./chengjiChange.vue?vue&type=script&lang=js"
import style0 from "./chengjiChange.vue?vue&type=style&index=0&id=0139275f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0139275f",
  null
  
)

export default component.exports